<template>
    <!-- <div fluid> -->
    <div v-if="loading" class="d-flex justify-center">
        <v-progress-circular indeterminate size="64" />
    </div>
    <v-container fluid v-else>
        <v-card class="default_card large mx-0 my-2 pa-2 sticky-card" elevation="0">
            <v-row no-gutters v-if="!previewMode">
                <v-col cols="6" class="d-flex justify-start align-center">
                    <v-btn-back class="ml-1 mr-5" @click.stop="back()"> </v-btn-back>
                </v-col>
                <v-col cols="6" class="d-flex align-end justify-end">
                    <v-text-field-filled
                        v-model="themeDB.name"
                        label="Nom du thème"
                        hide-details
                        :disabled="readonly"
                        density="compact"
                    />
                    <!-- <v-btn elevation="0" class="ml-1" @click="scopeDialog = true">
                        Pour qui ?
                    </v-btn> -->
                    <v-btn
                        elevation="0"
                        class="ml-1"
                        :disabled="!themeDB.name || readonly || !!!scopeId"
                        @click="upsertTheme()"
                    >
                        {{ id ? "Modifier" : "Créer" }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <div style="height: 75vh; overflow: auto">
            <v-row class="mt-1 ml-1" style="width: 99.5%; padding-bottom: 20px">
                <v-col
                    class="pb-0"
                    :cols="previewMode ? '12' : '6'"
                    style="max-height: calc(100vh - 180px); overflow-y: auto"
                >
                    <v-tabs
                        v-model="activeTab"
                        fixed-tabs
                        style="background-color: transparent !important; border-radius: 12px"
                        class="mb-1"
                    >
                        <v-tab
                            ripple
                            v-if="showFirstPageSettings"
                            value="showFirstPageSettings"
                            href="#showFirstPageSettings"
                            >Première page</v-tab
                        >
                        <v-tab
                            ripple
                            v-if="showNextSettings"
                            value="showNextSettings"
                            href="#showNextSettings"
                            >Pages Suivantes</v-tab
                        >
                        <!-- <v-tab ripple v-if="showStyleSettings" key="showStyleSettings" href="#showStyleSettings" data-cy="booklet-showStyleSettings-tab">Styles</v-tab> -->
                    </v-tabs>
                    <v-tabs-window
                        v-model="activeTab"
                        class="pt-2"
                        style="border: 1px solid #f4f4f4; background-color: #ffffff"
                    >
                        <v-window-item value="showFirstPageSettings" class="fill-height ml-2 mr-2">
                            <v-row
                                no-gutters
                                class="d-flex align-content-space-between flex-wrap fill-height"
                            >
                                <v-col cols="12" style="min-height: 140px">
                                    <v-row no-gutters>
                                        <v-col
                                            v-if="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                            "
                                            :cols="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '7'
                                                    : '4'
                                            "
                                        >
                                        </v-col>
                                        <v-col cols="2" :class="classFirstPageAccountingFirm()">
                                            <v-img
                                                v-if="
                                                    themeSettings.firstPage.accountingFirm.logo &&
                                                    themeSettings.firstPage.accountingFirm.position.startsWith(
                                                        'top-',
                                                    )
                                                "
                                                class="v-responsive"
                                                :src="logo"
                                                style="width: 100%; max-width: 80px; height: auto"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '3'
                                                    : '6'
                                            "
                                            :class="classFirstPageAccountingFirm()"
                                        >
                                            <v-row no-gutters :style="accountingFirmStyle()">
                                                <v-col
                                                    cols="12"
                                                    :class="classFirstPageAccountingFirm()"
                                                >
                                                    {{
                                                        themeSettings.firstPage.accountingFirm.position.startsWith(
                                                            "top-",
                                                        )
                                                            ? accountingFirmFirstPage
                                                            : ""
                                                    }}
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" style="min-height: 512px">
                                    <v-row no-gutters>
                                        <v-col cols="3" />
                                        <v-col cols="6">
                                            <v-row no-gutters :style="clientStyle()">
                                                <v-col
                                                    cols="12"
                                                    class="d-flex justify-center"
                                                    style="font-size: 24px"
                                                >
                                                    {{
                                                        themeSettings.firstPage.miscellaneous.title
                                                            ? bookletTemplateTest.miscellaneous
                                                                  .title
                                                            : ""
                                                    }}
                                                </v-col>
                                                <v-col cols="12" class="d-flex justify-center">
                                                    {{
                                                        (themeSettings.firstPage.client.legalForm
                                                            ? bookletTemplateTest.client.legalForm +
                                                              " "
                                                            : "") +
                                                        (themeSettings.firstPage.client.name
                                                            ? bookletTemplateTest.client.name
                                                            : "")
                                                    }}
                                                </v-col>
                                                <v-col cols="12" class="d-flex justify-center">
                                                    {{
                                                        themeSettings.firstPage.client.address
                                                            ? bookletTemplateTest.client.address
                                                            : ""
                                                    }}
                                                </v-col>
                                                <v-col cols="12" class="d-flex justify-center">
                                                    {{
                                                        themeSettings.firstPage.client.siret
                                                            ? bookletTemplateTest.client.siret
                                                            : ""
                                                    }}
                                                </v-col>
                                                <v-col cols="12" class="d-flex justify-center">
                                                    {{
                                                        themeSettings.firstPage.client.ape
                                                            ? bookletTemplateTest.client.ape
                                                            : ""
                                                    }}
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3" />
                                    </v-row>
                                </v-col>
                                <v-col cols="12" style="min-height: 50px">
                                    <v-row no-gutters>
                                        <v-col
                                            v-if="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                            "
                                            :cols="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '7'
                                                    : '4'
                                            "
                                        >
                                        </v-col>
                                        <v-col cols="2" :class="classFirstPageAccountingFirm()">
                                            <v-img
                                                v-if="
                                                    themeSettings.firstPage.accountingFirm.logo &&
                                                    themeSettings.firstPage.accountingFirm.position.startsWith(
                                                        'bottom-',
                                                    )
                                                "
                                                class="v-responsive"
                                                :src="logo"
                                                style="width: 100%; max-width: 80px; height: auto"
                                            />
                                        </v-col>
                                        <v-col
                                            :cols="
                                                themeSettings.firstPage.accountingFirm.logo &&
                                                themeSettings.firstPage.accountingFirm.position.endsWith(
                                                    'right',
                                                )
                                                    ? '3'
                                                    : '6'
                                            "
                                            :class="classFirstPageAccountingFirm()"
                                        >
                                            <v-row no-gutters :style="accountingFirmStyle()">
                                                <v-col
                                                    cols="12"
                                                    :class="classFirstPageAccountingFirm()"
                                                >
                                                    {{
                                                        themeSettings.firstPage.accountingFirm.position.startsWith(
                                                            "bottom-",
                                                        )
                                                            ? accountingFirmFirstPage
                                                            : ""
                                                    }}
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-window-item>
                        <v-window-item
                            value="showNextSettings"
                            class="fill-height mx-5"
                            style="max-height: calc(100vh-240px); overflow-y: auto"
                        >
                            <v-row
                                no-gutters
                                class="d-flex align-content-space-between flex-wrap fill-height"
                            >
                                <v-col cols="12" style="min-height: 140px" class="px-2">
                                    <v-row no-gutters>
                                        <v-col cols="12" :class="classNextPages()">
                                            <v-row no-gutters>
                                                <v-col cols="6">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            v-if="toDisplayLogo('top-left')"
                                                            cols="4"
                                                            class="d-flex justify-start align-left"
                                                        >
                                                            <v-img
                                                                class="v-responsive"
                                                                :src="logo"
                                                                style="
                                                                    width: 100%;
                                                                    max-width: 80px;
                                                                    height: auto;
                                                                "
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            v-else
                                                            cols="4"
                                                            class="d-flex justify-start align-left"
                                                        >
                                                            {{ displayInformations("top-left") }}
                                                        </v-col>
                                                        <v-col cols="4" />
                                                        <v-col cols="4" />
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-row no-gutters>
                                                        <v-col cols="4" />
                                                        <v-col cols="4"> </v-col>
                                                        <v-col
                                                            v-if="toDisplayLogo('top-right')"
                                                            cols="4"
                                                            class="d-flex justify-end align-right"
                                                        >
                                                            <v-img
                                                                class="v-responsive"
                                                                :src="logo"
                                                                style="
                                                                    width: 100%;
                                                                    max-width: 80px;
                                                                    height: auto;
                                                                "
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            v-else
                                                            cols="4"
                                                            class="d-flex justify-end align-right"
                                                        >
                                                            {{ displayInformations("top-right") }}
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-divider />
                                </v-col>
                                <v-col cols="12" style="min-height: 512px">
                                    <!-- centre de la page, insérer le tableau ici -->
                                    <h1>{{ bookletTableTemplate.name }}</h1>
                                    <table :style="tableGeneralStyle()">
                                        <thead :style="tableHeaderStyle(null)">
                                            <tr :style="tableHeaderStyle(null)">
                                                <td
                                                    v-for="(header, hi) in headerBookletTable"
                                                    :key="'header_' + hi"
                                                    :style="tableHeaderStyle(header)"
                                                >
                                                    {{ header.text }}
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(row, ri) in bookletTableTemplate.rows"
                                                :key="'row_' + ri"
                                            >
                                                <tr :style="tableRowsStyle(null)">
                                                    <td :style="tableRowsStyle(row)">
                                                        {{ row.title }}
                                                    </td>
                                                    <td :style="tableRowsStyle()">
                                                        {{ row.netAmounts[0] }}
                                                    </td>
                                                    <td :style="tableRowsStyle()">
                                                        {{ row.netAmounts[1] }}
                                                    </td>
                                                </tr>
                                                <tr
                                                    v-for="(subrow, si) in row.subrows"
                                                    :key="'subrow_' + ri + si"
                                                    :style="tableRowsStyle(null)"
                                                >
                                                    <td :style="tableRowsStyle(subrow)">
                                                        {{ subrow.name }}
                                                    </td>
                                                    <td :style="tableRowsStyle(null)">
                                                        {{ subrow.netAmounts[0] }}
                                                    </td>
                                                    <td :style="tableRowsStyle(null)">
                                                        {{ subrow.netAmounts[1] }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tfoot :style="tableFooterStyle()">
                                            <tr :style="tableFooterStyle()">
                                                <td :style="tableFooterStyle()" />
                                                <td :style="tableFooterStyle()">Total N-1</td>
                                                <td :style="tableFooterStyle()">Total N</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </v-col>
                                <v-col cols="12" />
                                <v-col cols="12" />
                                <v-col cols="12" />
                                <v-col cols="12" style="min-height: 50px">
                                    <v-divider class="d-flex justify-end align-center mt-6 mb-3" />
                                    <v-row no-gutters>
                                        <v-col cols="6">
                                            <v-row no-gutters>
                                                <v-col
                                                    v-if="toDisplayLogo('bottom-left')"
                                                    cols="6"
                                                    class="d-flex justify-start align-start"
                                                >
                                                    <v-img
                                                        class="v-responsive"
                                                        :src="logo"
                                                        style="
                                                            width: 100%;
                                                            max-width: 80px;
                                                            height: auto;
                                                        "
                                                    />
                                                </v-col>
                                                <v-col
                                                    v-else
                                                    cols="6"
                                                    class="d-flex justify-start align-start"
                                                >
                                                    {{ displayInformations("bottom-left") }}
                                                </v-col>
                                                <v-col cols="6" />
                                            </v-row>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-row no-gutters>
                                                <v-col cols="6" />
                                                <v-col
                                                    v-if="toDisplayLogo('bottom-right')"
                                                    cols="6"
                                                    class="d-flex justify-end align-start"
                                                >
                                                    <v-img
                                                        class="v-responsive"
                                                        :src="logo"
                                                        style="
                                                            width: 100%;
                                                            max-width: 80px;
                                                            height: auto;
                                                        "
                                                    />
                                                </v-col>
                                                <v-col
                                                    v-else
                                                    cols="6"
                                                    class="d-flex justify-end align-start"
                                                >
                                                    {{ displayInformations("bottom-right") }}
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-window-item>
                    </v-tabs-window>
                </v-col>
                <v-col
                    v-if="!previewMode"
                    cols="6"
                    style="max-height: calc(100vh - 170px); overflow-y: auto"
                >
                    <v-card class="fill-height default_card_wm elevation-0">
                        <ExportThemeMenu
                            :themeSettings="themeSettings"
                            :activeTab="activeTab"
                            :readonly="readonly"
                            @emit-step="changeActiveTab($event)"
                        >
                        </ExportThemeMenu>
                    </v-card>
                </v-col>
            </v-row>
            <ScopeManager
                v-model="scopeSync"
                v-model:id="scopeId"
                v-model:name="scopeName"
                :readonly="readonly"
                style="width: 99%"
            />
        </div>

        <!-- <oss-dialog v-model="scopeDialog" @valid="scopeDialog = false" min-width="750px">
            <ScopeManager 
                v-model="scopeSync" 
                v-model:id="scopeId" 
                v-model:name="scopeName"
                :readonly="readonly"
            />
        </oss-dialog> -->
    </v-container>
    <!-- </div> -->
</template>
<script lang="ts">
import { User } from "../../store/store";

import ExportThemeMenu from "./ExportThemeMenu.vue";
import { Apollo } from "@/decorators";
import ACCOUNTING_COMPANY_OF_COMPANY from "../../graphql/company/AccountingCompanyOfCompany.gql";
import EXPORT_THEME from "../../graphql/exportTheme/ExportTheme.gql";
import UPSERT_EXPORT_THEME from "../../graphql/exportTheme/UpsertExportTheme.gql";
import ScopeManager from "../companyScope/ScopeManager.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { Ref } from "vue-facing-decorator";

@Component({
    components: {
        ExportThemeMenu,
        ScopeManager,
    },
})
export class ExportThemeEdition extends Vue {
    @Prop({ default: "" }) id: string;
    @Prop({ default: null }) themeSettingsFromProp: any;
    @Prop({ default: false }) previewMode: boolean;
    @Prop({ default: true }) showFirstPageSettings!: boolean;
    @Prop({ default: true }) showNextSettings!: boolean;
    @Prop({ default: true }) showStyleSettings!: boolean;
    @Prop({ default: "" }) idToDuplicate: string;

    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    loading: boolean = true;

    readonly = false;

    activeTab = "showFirstPageSettings";

    scopeDialog = false;

    validationForAllAccountingCompany = false;

    bookletTemplateTest = {
        accountingFirm: {
            name: "Nom Cabinet",
            address: "Adresse Cabinet",
            siret: "Siret Cabinet",
        },
        client: {
            name: "Nom client",
            address: "Adresse client",
            siret: "Siret Client",
            ape: "APE client",
            legalForm: "Forme juridique",
        },
        miscellaneous: {
            bobbee: "bobbee",
            pagination: "Pagination",
            title: "Titre du document",
        },
    };

    bookletTableTemplate = {
        name: "Nom du tableau",
        rows: [
            {
                title: "Titre 1",
                subtitle: "Sous titre 1",
                netAmounts: ["1280", "360"],
                subrows: [
                    {
                        name: "Sous Titre 1",
                        netAmounts: ["1000", "300"],
                    },
                    {
                        name: "Sous Titre 1",
                        netAmounts: ["280", "60"],
                    },
                ],
            },
            {
                title: "Titre 2",
                subtitle: "Sous titre 2",
                netAmounts: ["1345", "254"],
                subrows: [
                    {
                        name: "Sous Titre 2",
                        netAmounts: ["1000", "200"],
                    },
                    {
                        name: "Sous Titre 2",
                        netAmounts: ["345", "54"],
                    },
                ],
            },
        ],
    };

    defaultTheme = {
        theme: {
            firstPage: {
                accountingFirm: {
                    address: true,
                    siret: false,
                    name: true,
                    logo: true,
                    position: "bottom-left",
                    style: {
                        fontFamily: "",
                        fontWeight: "",
                        borderColor: "",
                        border: false,
                    },
                },
                client: {
                    address: true,
                    siret: true,
                    ape: true,
                    legalForm: false,
                    name: true,
                    logo: true,
                    position: "",
                    style: {
                        fontFamily: "",
                        fontWeight: "",
                        borderColor: "",
                        border: false,
                    },
                },
                miscellaneous: {
                    bobbee: false,
                    pagination: false,
                    title: true,
                },
            },
            pages: {
                accountingFirm: {
                    address: false,
                    siret: false,
                    name: false,
                    logo: true,
                    // position:"",
                    style: {
                        fontFamily: "",
                        fontWeight: "",
                        borderColor: "",
                        border: false,
                    },
                },
                client: {
                    address: false,
                    siret: false,
                    ape: false,
                    name: true,
                    logo: false,
                    // position:"",
                    style: {
                        fontFamily: "",
                        fontWeight: "",
                        borderColor: "",
                        border: false,
                    },
                },
                miscellaneous: {
                    bobbee: false,
                    pagination: false,
                    title: true,
                },
                position: {
                    client: "top-right",
                    accountingFirm: "top-left",
                    title: "bottom-left",
                    pagination: "bottom-right",
                },
                tables: {
                    header: {
                        fontFamily: "",
                        fontColor: "",
                        fontWeight: "",
                        borderColor: "",
                        borderBottom: false,
                        backgroundColor: "#efefef",
                    },
                    rows: {
                        border: true,
                        fontWeight: "",
                        borderBottom: false,
                        borderColor: "#efefef",
                        backgroundColor: "#f5f5f5",
                    },
                    footer: {
                        fontFamily: "",
                        fontWeight: "",
                        borderColor: "",
                        totalColorSeparator: "#f9b128",
                        borderTop: true,
                        backgroundColor: "#efefef",
                    },
                },
            },
        },
    };

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    get themeSettings() {
        if (this.themeSettingsFromProp) {
            return this.themeSettingsFromProp;
        } else {
            return this.themeDB.theme;
        }
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get accountingFirmFirstPage() {
        let accountingFirm = "";

        if (this.themeSettings?.firstPage?.accountingFirm?.name) {
            accountingFirm += this.bookletTemplateTest.accountingFirm.name + " ";
        }

        if (this.themeSettings?.firstPage?.accountingFirm?.address) {
            accountingFirm += this.bookletTemplateTest.accountingFirm.address + " ";
        }

        if (this.themeSettings?.firstPage?.accountingFirm?.siret) {
            accountingFirm += this.bookletTemplateTest.accountingFirm.siret;
        }

        return accountingFirm;
    }

    get logo() {
        if (
            this.isAccountingUser &&
            this.currentUser &&
            this.currentUser.company &&
            this.currentUser.company.logo &&
            this.currentUser.company.logo.signedUrl
        ) {
            return this.currentUser.company.logo.signedUrl;
        }
        if (
            !this.isAccountingUser &&
            this.accountingFirm &&
            this.accountingFirm.logo &&
            this.accountingFirm.logo.signedUrl
        ) {
            return this.accountingFirm.logo.signedUrl;
        }
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get clientCompaniesIds() {
        const result = [];
        for (const company of this.currentUser.allAvailableCompanies) {
            result.push(company.id);
        }
        return result;
    }

    get headerBookletTable() {
        const header: Array<any> = [
            { text: "Nom", value: "title", align: "left", sortable: false },
            { text: "N-1", value: "0", align: "right", sortable: false },
            { text: "N", value: "1", align: "right", sortable: false },
        ];
        return header;
    }

    @Apollo({
        query: EXPORT_THEME,
        variables() {
            return {
                id: this.id || this.idToDuplicate,
            };
        },
        result({ data, loading }: any) {
            if (!loading) {
                if (data?.exportTheme) {
                    this.themeDB.name = this.idToDuplicate ? "" : data.exportTheme?.name;
                    this.themeDB.theme = JSON.parse(JSON.stringify(data.exportTheme.theme));
                    this.scopeId = this.idToDuplicate ? "" : data.exportTheme.companyScope.id;
                    this.scopeName = this.idToDuplicate ? "" : data.exportTheme.companyScope.name;
                    this.isReadOnly(
                        data.exportTheme.companyScope.accountingCompany,
                        data.exportTheme.companyScope.accountingCompanyOwner,
                    );
                } else {
                    this.themeDB.theme = this.defaultTheme.theme;
                }
                this.loading = false;
            }
        },
    })
    themeDB: any = {
        accountingCompanyId: {
            id: "",
            name: "",
        },
        name: "",
        theme: {},
    };

    @Apollo({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables() {
            return {
                companyId: this.currentUser.company.id,
            };
        },
        skip() {
            return !this.currentUser.id || this.isAccountingUser;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.companies && data.companies.length) {
                    this.accountingFirm = data.companies[0];
                }
            }
        },
    })
    accountingFirm = null;

    async upsertTheme() {
        const result = await this.$apollo.mutate({
            mutation: UPSERT_EXPORT_THEME,
            variables: {
                id: this.id,
                name: this.themeDB.name,
                createAccountingCompany: { connect: { id: this.accountingCompanyId } },
                updateAccountingCompany: { connect: { id: this.accountingCompanyId } },
                scopeId: this.scopeId ? this.scopeId : undefined,
                theme: this.themeSettings,
            },
        });

        if (result) {
            this.$router.go(-1);
        }
    }

    changeActiveTab(stepFromChild) {
        switch (stepFromChild) {
            case "showNextSettings":
                this.activeTab = "showNextSettings";
                break;
            case "showFirstPageSettings":
                this.activeTab = "showFirstPageSettings";
                break;
        }
    }

    classFirstPageAccountingFirm() {
        if (this.themeSettings?.firstPage?.accountingFirm?.position) {
            return {
                "d-flex": true,
                "justify-end": this.themeSettings?.firstPage?.accountingFirm?.position.endsWith(
                    "-right",
                )
                    ? true
                    : false,
                "align-end": this.themeSettings?.firstPage?.accountingFirm?.position.startsWith(
                    "bottom-",
                )
                    ? true
                    : false,
            };
        }
    }

    classNextPages() {
        if (this.themeSettings?.pages?.position?.accountingFirm) {
            return {
                "d-flex": true,
                "justify-end": this.themeSettings?.pages?.position?.accountingFirm.endsWith(
                    "-right",
                )
                    ? true
                    : false,
                "align-end": this.themeSettings?.pages?.position?.accountingFirm.startsWith(
                    "bottom-",
                )
                    ? true
                    : false,
            };
        }
    }

    clientStyle() {
        if (this.themeSettings?.firstPage?.client?.style) {
            return {
                border: this.themeSettings?.firstPage?.client?.style?.border
                    ? "1px solid black"
                    : "0px",
                // "border-color":"red",
                "font-weight": this.themeSettings?.firstPage?.client?.style?.fontWeight
                    ? this.themeSettings?.firstPage?.client?.style?.fontWeight
                    : "",
                "font-family": this.themeSettings?.firstPage?.client?.style?.fontFamily
                    ? this.themeSettings?.firstPage?.client?.style?.fontFamily
                    : "",
            };
        }

        return "";
    }

    accountingFirmStyle() {
        if (this.themeSettings?.firstPage?.accountingFirm?.style) {
            return {
                border: this.themeSettings?.firstPage?.accountingFirm?.style?.border
                    ? "1px solid black"
                    : "0px",
                // "border-color":"red",
                "font-size": "9px",
                "font-weight": this.themeSettings?.firstPage?.accountingFirm?.style?.fontWeight
                    ? this.themeSettings?.firstPage?.accountingFirm?.style?.fontWeight
                    : "",
                "font-family": this.themeSettings?.firstPage?.accountingFirm?.style?.fontFamily
                    ? this.themeSettings?.firstPage?.accountingFirm?.style?.fontFamily
                    : "",
            };
        }

        return "";
    }

    @Watch("themeSettings", { deep: true })
    tableGeneralStyle() {
        if (this.themeSettings?.pages?.tables) {
            return {
                "padding-right": "10px",
                border: this.themeSettings?.pages?.tables?.rows.border ? "1px" : "0px",
                "border-collapse": "collapse",
                width: "100%",
            };
        }
    }

    tableHeaderStyle(row) {
        if (this.themeSettings?.pages?.tables?.header) {
            return {
                "text-align": row && row.text === "Nom" ? "start" : "end",
                "padding-right": "10px",
                "border-collapse": "collapse",
                "border-style": this.themeSettings?.pages?.tables?.rows.border ? "solid" : "none",
                "border-top-width": this.themeSettings?.pages?.tables?.rows.border ? "1px" : "0px",
                "border-left-width": this.themeSettings?.pages?.tables?.rows.border ? "1px" : "0px",
                "border-right-width": this.themeSettings?.pages?.tables?.rows.border
                    ? "1px"
                    : "0px",
                "border-bottom-width": this.themeSettings?.pages?.tables?.rows.border
                    ? "1px"
                    : "0px",
                "border-color": this.themeSettings?.pages?.tables?.rows?.borderColor
                    ? this.themeSettings.pages.tables.rows.borderColor
                    : "black",
                "background-color": this.themeSettings?.pages?.tables?.header?.backgroundColor
                    ? this.themeSettings.pages.tables.header.backgroundColor
                    : "",
                "font-weight": this.themeSettings?.pages?.tables?.header?.fontWeight
                    ? this.themeSettings?.pages?.tables?.header?.fontWeight
                    : "",
            };
        }
    }

    tableRowsStyle(row) {
        if (this.themeSettings?.pages?.tables?.rows) {
            return {
                "text-align": row ? "start" : "end",
                "padding-right": "10px",
                "border-collapse": "collapse",
                "border-style": this.themeSettings?.pages?.tables?.rows.border ? "solid" : "none",
                "border-bottom-style": "none",
                "border-top-width": this.themeSettings?.pages?.tables?.rows?.border ? "1px" : "0px",
                "border-left-width": this.themeSettings?.pages?.tables?.rows?.border
                    ? "1px"
                    : "0px",
                "border-right-width": this.themeSettings?.pages?.tables?.rows?.border
                    ? "1px"
                    : "0px",
                "border-bottom-width": this.themeSettings?.pages?.tables?.rows?.border
                    ? "1px"
                    : "0px",
                "border-color": this.themeSettings?.pages?.tables?.rows?.borderColor
                    ? this.themeSettings.pages.tables.rows.borderColor
                    : "#efefef",
                "background-color": this.themeSettings?.pages?.tables?.rows?.backgroundColor
                    ? this.themeSettings.pages.tables.rows.backgroundColor
                    : "",
                "font-weight": this.themeSettings?.pages?.tables?.rows?.fontWeight
                    ? this.themeSettings?.pages?.tables?.rows?.fontWeight
                    : "",
            };
        }
    }

    tableFooterStyle() {
        if (this.themeSettings?.pages?.tables?.footer) {
            return {
                "text-align": "end",
                "padding-right": "10px",
                "border-collapse": "collapse",
                "border-left-style": this.themeSettings?.pages?.tables?.rows?.border
                    ? "solid"
                    : "none",
                "border-right-style": this.themeSettings?.pages?.tables?.rows?.border
                    ? "solid"
                    : "none",
                "border-top-style":
                    this.themeSettings?.pages?.tables?.footer?.totalColorSeparator &&
                    this.themeSettings?.pages?.tables?.footer?.borderTop
                        ? "solid"
                        : "none",
                "border-bottom-style": this.themeSettings?.pages?.tables?.rows?.border
                    ? "solid"
                    : "none",
                "border-top-width": this.themeSettings?.pages?.tables?.footer?.borderTop
                    ? "2px"
                    : "1px",
                "border-bottom-width": "1px",
                "border-left-width": "1px",
                "border-right-width": "1px",
                "border-top-color":
                    this.themeSettings?.pages?.tables?.footer?.totalColorSeparator &&
                    this.themeSettings?.pages?.tables?.footer?.borderTop
                        ? this.themeSettings.pages.tables.footer.totalColorSeparator
                        : "#efefef",
                "border-left-color": this.themeSettings?.pages?.tables?.rows?.borderColor
                    ? this.themeSettings.pages.tables.rows.borderColor
                    : "#efefef",
                "border-right-color": this.themeSettings?.pages?.tables?.rows?.borderColor
                    ? this.themeSettings.pages.tables.rows.borderColor
                    : "#efefef",
                "border-bottom-color": this.themeSettings?.pages?.tables?.rows?.borderColor
                    ? this.themeSettings.pages.tables.rows.borderColor
                    : "#efefef",
                "font-weight": this.themeSettings?.pages?.tables?.footer?.fontWeight
                    ? this.themeSettings.pages.tables.footer.fontWeight
                    : "",
                "background-color": this.themeSettings?.pages?.tables?.footer?.backgroundColor
                    ? this.themeSettings.pages.tables.footer.backgroundColor
                    : "",
            };
        }
    }

    back() {
        this.$router.go(-1);
    }

    displayInformations(position) {
        for (const pos in this.themeSettings.pages.position) {
            if (
                this.themeSettings.pages.position[pos] === position &&
                pos !== "title" &&
                pos !== "pagination"
            ) {
                return this.bookletTemplateTest[pos].name;
            }
            if (this.themeSettings.pages.position[pos] === position && pos === "title") {
                if (this.themeSettings.pages.miscellaneous.title) {
                    return this.bookletTemplateTest.miscellaneous.title;
                }
            }
            if (this.themeSettings.pages.position[pos] === position && pos === "pagination") {
                return "2/5";
            }
        }

        return "";
    }

    toDisplayLogo(position) {
        for (const pos in this.themeSettings.pages.position) {
            if (this.themeSettings.pages.position[pos] === position && pos !== "title") {
                if (this.themeSettings?.pages[pos]?.logo) {
                    this.themeSettings.pages[pos].name = false;
                    return this.themeSettings.pages[pos].logo
                        ? this.themeSettings.pages[pos].logo
                        : false;
                }
            }
        }
    }

    isReadOnly(accountingCompany, accountingCompanyOwner) {
        // if modified also change isReadOnlys used with other components using <Scope>
        if (accountingCompany == null && accountingCompanyOwner.id !== this.accountingCompanyId) {
            this.readonly = true;
        }
    }
}

export default toNative(ExportThemeEdition);
</script>

<style>
.sticky-card {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: white;
}
</style>
